import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormatDateWTime } from "../../../utils/FormatData";
import _Button from "../../generic/_Button";
import _ModalViewer from "./_ModalViewer";
const RCSCardLog = (props) => {
  const {
    uid_transaction,
    time_id,
    vc_msisdn,
    vc_response,
    vc_tipo,
    b_ok,
    time_response,
    vc_source,
    vc_agent,
  } = props.data;

  const [visible, setVisible] = useState({ visible: null, data: null });

  const mapType = {
    file: {
      icon: "attach_file",
      label: "Archivo",
    },
    "pull-text": {
      icon: "text_snippet",
      label: "Texto",
    },
  };
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-4 py-2 my-1">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-center gap-2">
          <span className="material-symbols-outlined">phone</span>
          <div className="font-semibold text-sm text-gray-900">{vc_msisdn}</div>

          <div className="text-sm px-2 my-1 rounded-lg bg-blue-200">
            <span className="font-[500] text-blue-500">{vc_agent}</span>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2">
          <div className="text-sm px-2 my-1 rounded-lg bg-gray-200 flex items-center gap-1">
            <span className="material-symbols-outlined my-0.5">
              {mapType[vc_tipo].icon}
            </span>
            <span className="font-[400]">{mapType[vc_tipo].label}</span>
          </div>
          <div
            className={`text-sm px-2 my-1 py-0.5 rounded-full ${
              b_ok ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
            }`}
          >
            <span className="font-semibold">{b_ok ? "ACEPTADO" : "ERROR"}</span>
          </div>
        </div>
      </div>

      {/* Response */}
      {vc_tipo !== "file" ? (
        <div className="bg-gray-50 border border-gray-100 rounded-md p-2 text-xs font-mono text-gray-700 overflow-ellipsis">
          {vc_response}
        </div>
      ) : null}

      {/* Meta grid */}
      <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-[12px] text-gray-600 font-semibold mt-2 mb-2">
        <div>
          <span className="text-gray-400">Origen:</span> {vc_source}
        </div>

        <div>
          <span className="text-gray-400">Id Transacción:</span>{" "}
          {uid_transaction}
        </div>
        <div>
          <span className="text-gray-400">Envio:</span>{" "}
          {FormatDateWTime(time_id)}
        </div>

        <div>
          <span className="text-gray-400">Respuesta:</span>{" "}
          {FormatDateWTime(time_response)}
        </div>

        {vc_tipo === "file" ? (
          <_Button
            icon="preview"
            title="Previsualizar"
            onClick={() => setVisible({ visible: true, data: vc_response })}
            style="none"
            className="w-full"
          />
        ) : null}
      </div>

      <_ModalViewer
        visible={visible.visible}
        onClose={() => setVisible({ visible: false, data: null })}
        data={visible.data}
      />
    </div>
  );
};

RCSCardLog.propTypes = {
  data: PropTypes.object,
};

export default RCSCardLog;
